import { render, staticRenderFns } from "./NxHeader.vue?vue&type=template&id=061ac44c&scoped=true&"
import script from "./NxHeader.vue?vue&type=script&lang=js&"
export * from "./NxHeader.vue?vue&type=script&lang=js&"
import style0 from "./NxHeader.vue?vue&type=style&index=0&id=061ac44c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ac44c",
  null
  
)

export default component.exports